// extracted by mini-css-extract-plugin
export default {"Todo":"Todo_Todo__tLjPl","Todo-buttons":"Todo_Todo-buttons__Wx5ij","Todo-edit-form":"Todo_Todo-edit-form__VlH2d","strikeitem":"Todo_strikeitem__cEVE2"};